import { Navigate, Outlet } from 'react-router-dom';
import { useCurrentUser } from '@/hooks/use-current-user';
import { FullPageLoader } from 'prosci-ui';

export function SuperOrDataAdminRoute() {
  const { data: currentUser, isLoading } = useCurrentUser();

  if (isLoading) {
    return <FullPageLoader message="Loading..." />;
  }

  const isAllowed =
    currentUser?.level === 'super' || currentUser?.level === 'data';

  if (!isAllowed) {
    return <Navigate to="/users" replace />;
  }

  return <Outlet />;
}
